var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXClose = function SvgXClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54001 3.54036C3.79385 3.28652 4.20541 3.28652 4.45925 3.54036L7.99963 7.08074L11.54 3.54036C11.7939 3.28652 12.2054 3.28652 12.4593 3.54036C12.7131 3.7942 12.7131 4.20575 12.4593 4.45959L8.91887 7.99998L12.4592 11.5403C12.7131 11.7942 12.7131 12.2057 12.4592 12.4596C12.2054 12.7134 11.7938 12.7134 11.54 12.4596L7.99963 8.91921L4.45923 12.4596C4.20539 12.7135 3.79383 12.7135 3.53999 12.4596C3.28615 12.2058 3.28615 11.7942 3.53999 11.5404L7.08039 7.99998L3.54001 4.45959C3.28617 4.20575 3.28617 3.7942 3.54001 3.54036Z",
    fill: "currentColor"
  })));
};
export default SvgXClose;